import { createReducer, on } from '@ngrx/store';
import { FullscreenLayoutAreas } from '@src/assets/css/fullscreen.template.scss';
import { FourthSidecarActions, FullscreenActions, SidecarEfffectActions } from '@src/suite/common/store/fullscreen/actions/fullscreen.actions';
import { SidecarMenu, SidecarState } from '@src/suite/common/store/fullscreen/models/fullscreen.models';

import { BASE_SIDECAR_INITIAL_STATE } from './fullscreen.reducer';

export const fourthSidecarInitialState: SidecarState = {
    ...BASE_SIDECAR_INITIAL_STATE,
};

export const fourthSidecarReducer = createReducer(
    fourthSidecarInitialState,
    on(
        FullscreenActions.resetState,
        (): SidecarState => ({
            ...fourthSidecarInitialState,
        })
    ),
    on(
        FourthSidecarActions.selectSidecarMenu,
        (state, { menu }): SidecarState => ({
            ...state,
            selected: menu,
        })
    ),
    on(
        FourthSidecarActions.selectSidecarAssignment,
        (state, { assignmentGuid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.ASSIGNMENTS,
            selectedAssignmentGuid: assignmentGuid,
        })
    ),
    on(FourthSidecarActions.setAssignmentViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedAssignmentViewStates: viewStates,
        };
    }),
    on(FourthSidecarActions.setCurrentAssignmentViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentAssignmentViewStateGuid: guid || null,
        };
    }),
    on(FourthSidecarActions.setAssignmentListGuids, (state, { assignmentGuids: topicGuids }): SidecarState => {
        return {
            ...state,
            assignmentListGuids: topicGuids,
        };
    }),
    on(FourthSidecarActions.setTopicViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedTopicViewStates: viewStates,
        };
    }),
    on(FourthSidecarActions.setCurrentTopicViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicViewStateGuid: guid || null,
        };
    }),
    on(FourthSidecarActions.setTopicListGuids, (state, { topicGuids }): SidecarState => {
        return {
            ...state,
            topicListGuids: topicGuids,
        };
    }),
    on(FourthSidecarActions.setRundownViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedRundownViewStates: viewStates,
        };
    }),
    on(FourthSidecarActions.setCurrentRundownViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentRundownViewStateGuid: guid || null,
        };
    }),
    on(FourthSidecarActions.setRundownListGuids, (state, { rundownGuids }): SidecarState => {
        return {
            ...state,
            rundownListGuids: rundownGuids,
        };
    }),
    on(
        FourthSidecarActions.selectSidecarStory,
        (state, { guid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.STORIES,
            selectedStoryGuid: guid,
        })
    ),
    on(FourthSidecarActions.setStoryViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedStoryViewStates: viewStates,
        };
    }),
    on(FourthSidecarActions.setCurrentStoryViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentStoryViewStateGuid: guid || null,
        };
    }),
    on(FourthSidecarActions.setStoryListGuids, (state, { storyGuids }): SidecarState => {
        return {
            ...state,
            storyListGuids: storyGuids,
        };
    }),
    on(FourthSidecarActions.selectSidecarRundown, (state, { guid }): SidecarState => {
        return {
            ...state,
            selectedRundownGuid: guid,
        };
    }),
    on(FourthSidecarActions.selectSidecarTopic, (state, { guid }): SidecarState => {
        return {
            ...state,
            selectedTopicGuid: guid,
        };
    }),
    on(FourthSidecarActions.setCurrentROSelectedStory, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentRundownSelectedStoryGuid: guid,
        };
    }),
    on(FourthSidecarActions.setCurrentTopicSelectedStory, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicSelectedStoryGuid: guid,
        };
    }),
    on(FourthSidecarActions.setCurrentTopicSelectedAssignment, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicSelectedAssignmentGuid: guid,
        };
    }),
    on(
        FourthSidecarActions.setCurrentMosPlugin,
        (state, { mosPluginId: mosId }): SidecarState => ({
            ...state,
            selectedMosPluginID: mosId,
            selectedMosPluginInitialized: false,
        })
    ),
    on(
        FourthSidecarActions.resetMosState,
        (state): SidecarState => ({
            ...state,
            selectedMosPluginID: null,
            selectedMosPluginInitialized: false,
            selectedMosPluginPendingCommand: null,
        })
    ),
    on(
        FourthSidecarActions.setAssignmentsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedAssignmentListSearchType: searchType,
        })
    ),
    on(
        FourthSidecarActions.setStoriesListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedStoryListSearchType: searchType,
        })
    ),
    on(
        FourthSidecarActions.setTopicsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedTopicListSearchType: searchType,
        })
    ),
    on(
        FourthSidecarActions.setRundownsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedRundownListSearchType: searchType,
        })
    ),
    on(SidecarEfffectActions.openMosItemInSidecar, (state, { mosPluginId, mosItemCommand, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_FOURTH) {
            return {
                ...state,
                selectedMosPluginID: mosPluginId,
                selectedMosPluginPendingCommand: mosItemCommand,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.openPendingMosItem, (state, { mosPluginId, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_FOURTH && mosPluginId === state.selectedMosPluginID) {
            return {
                ...state,
                selectedMosPluginPendingCommand: null,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.setCurrentMosPluginInitialized, (state, { mosPluginId, sidecar }): SidecarState => {
        if (mosPluginId === state.selectedMosPluginID && sidecar === FullscreenLayoutAreas.SIDECAR_FOURTH) {
            return {
                ...state,
                selectedMosPluginInitialized: true,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.setRundownLayout, (state, { roGuid, layout, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_FOURTH) {
            const rundownState = new Map(state.rundownState);
            rundownState.set(roGuid, { selectedLayoutName: layout.name, selectedLayoutType: layout.type });
            return {
                ...state,
                rundownState,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.openSubStoriesInSidecar, (state, { sidecarType, parentGuid }): SidecarState => {
        if (sidecarType === FullscreenLayoutAreas.SIDECAR_FOURTH) {
            return { ...state, subStoriesParentGuid: parentGuid || null };
        }
        return state;
    }),
    on(SidecarEfffectActions.setCurrentSubStories, (state, { sidecarType, parentGuid }): SidecarState => {
        if (sidecarType === FullscreenLayoutAreas.SIDECAR_FOURTH) {
            return { ...state, subStoriesParentGuid: parentGuid };
        }
        return state;
    }),
    on(SidecarEfffectActions.clearStoryFromSidecar, (state, { sidecar, excludedMenus }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_FOURTH) {
            const newState = {
                ...state,
            };
            if (excludedMenus?.length) {
                excludedMenus.forEach(menu => {
                    switch (menu) {
                        case SidecarMenu.STORIES:
                            newState.currentRundownSelectedStoryGuid = null;
                            newState.currentTopicSelectedStoryGuid = null;
                            break;
                        case SidecarMenu.RUNDOWNS:
                            newState.selectedStoryGuid = null;
                            newState.currentTopicSelectedStoryGuid = null;
                            break;
                        case SidecarMenu.TOPICS:
                            newState.selectedStoryGuid = null;
                            newState.currentRundownSelectedStoryGuid = null;
                            break;
                    }
                });
                return newState;
            }
            newState.selectedStoryGuid = null;
            newState.currentRundownSelectedStoryGuid = null;
            newState.currentTopicSelectedStoryGuid = null;
            return newState;
        }
        return state;
    })
);
